// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__9NLIC","tab":"Tabs_tab__yrVcn","tab__active":"Tabs_tab__active__8xvCG Tabs_tab__yrVcn"};